module.exports = __webpack_public_path__ + "front/img/p8.f8d89df8.png";